/** Weekly commercial AG Grid JSON export (must match backend commercialAgGridWeeklyEmailTriggers.cjs). */

export const COMMERCIAL_AG_GRID_WEEKLY_EMAIL_TRIGGER_DEFINITIONS = [
  {
    id: "commercial_ag_grid_weekly_export",
    label: "Weekly commercial AG Grid JSON export (Monday 8am)",
    group: "Commercial Board",
    hardcodedTemplate: true,
    /** Recipients are typed email addresses, not User Matrix role types. */
    directRecipientEmails: true,
  },
];
